<template>
  <div
    class="modal fade"
    id="failed-search-modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="false"
  >
    <div class="alert-wide modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div>
          <button
            @click="closeModal"
            type="button"
            class="close close-modal m-5"
            aria-label="Close"
          >
            <!-- <span aria-hidden="true">&times;</span> -->
            <i class="fas fa-times fa-2x"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="swal2-icon d-flex swal2-info justify-content-center">
              <div class="swal2-icon-content">i</div>
            </div>
          </div>
          <div class="row mb-15 justify-content-center">
            <h3>{{ getPopUpTitle('propose-a-trip-modal') }}</h3>
          </div>

          <div class="row mt-2 mb-2 justify-content-center">
            <div class="col-12" v-html="getPopUpBody('propose-a-trip-modal')"></div>
          </div>

          <ValidationObserver v-slot="{ dirty, invalid }">
            <div class="row">
              <div class="col-12 mt-5">
                <ValidationProvider name="Email" rules="required|email" v-slot="{ errors }">
                  <div class="input-group mb-3">
                    <input
                      v-model="formData.email"
                      type="email"
                      class="form-control"
                      placeholder="Enter your email"
                      aria-label="Guest email"
                    />
                  </div>
                  <div class="invalid-feedback">{{errors[0]}}</div>
                </ValidationProvider>
              </div>

              <div class="col-12 mt-5">
                <ValidationProvider
                  name="Phone"
                  rules="phoneRestriction|required"
                  v-slot="{ errors } "
                >
                  <div class="input-group mb-3">
                    <input
                      v-model="formData.phone"
                      type="text"
                      class="form-control"
                      placeholder="Enter your phone"
                      aria-label="Guest phone"
                      v-mask="'(###) ###-####'"
                    />
                  </div>
                  <div class="invalid-feedback">{{errors[0]}}</div>
                </ValidationProvider>
              </div>

              <div v-if="errorMessages.length > 0" class="col-12 mt-7">
                <div
                  v-for="errorMessage in errorMessages"
                  :key="errorMessage"
                  class="invalid-feedback"
                >{{errorMessage}}</div>
              </div>
              <div class="col-12 mt-7">
                <!-- <p class="text-center">
                  <small
                    class="text-center"
                  >By registering and entering your email address and/or phone number you agree to be contacted both by email & phone. Message and data rates may apply.</small>
                </p> -->
              </div>

              <div class="col-md-4 mb-20">
                <button
                  class="btn-post-trip btn btn-light-blue position-relative w-100 py-15 mb-15"
                  @click="sharedFlight"
                  type="button"
                  :disabled="invalid || !dirty"
                >{{ getPopUpTitle('propose-a-trip-modal-shared-flight-button') }}</button>
                <div
                  v-html="getPopUpBody('propose-a-trip-modal-shared-flight-button')"
                  class="font-14"
                ></div>
              </div>
              <div class="col-md-4 mb-20">
                <button
                  class="btn btn-keep-searching btn-primary position-relative w-100 py-15 mb-15"
                  type="button"
                  @click="sharedPrivateFlight"
                  :disabled="invalid || !dirty"
                >{{ getPopUpTitle('propose-a-trip-modal-shared-private-flight-button') }}</button>
                <div
                  v-html="getPopUpBody('propose-a-trip-modal-shared-private-flight-button')"
                  class="font-14"
                ></div>
              </div>
              <div class="col-md-4 mb-20">
                <button
                  class="btn btn-keep-searching btn-primary position-relative w-100 py-15 mb-15"
                  type="button"
                  @click="privateFlight"
                  :disabled="invalid || !dirty"
                >{{ getPopUpTitle('propose-a-trip-modal-private-flight-button') }}</button>
                <div
                  v-html="getPopUpBody('propose-a-trip-modal-private-flight-button')"
                  class="font-14"
                ></div>
              </div>
            </div>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PopUpMixin from "@/mixins/dinamicPopUpMixin";
import TripStatusMixin from "@/mixins/TripStatusMixin";
import { mapState } from "vuex";

export default {
  mixins: [PopUpMixin, TripStatusMixin],
  props: {
    airportFrom: {
      type: Object,
      default: null
    },
    airportTo: {
      type: Object,
      default: null
    },
    errorMessages: {
      type: Array
    }
  },
  data() {
    return {
      formData: {
        email: null,
        phone: null
      }
    };
  },
  mounted() {
    if (this.guestEmail) {
      this.formData.email = this.guestEmail;
    }
    if (this.guestPhone) {
      this.formData.phone = this.guestPhone;
    }
  },
  methods: {
    sharedFlight() {
      this.$emit("optionSelected", {
        status: "verified",
        formData: this.formData
      });
    },
    sharedPrivateFlight() {
      this.$emit("optionSelected", {
        status: "shared-private",
        formData: this.formData
      });
    },
    privateFlight() {
      this.$emit("optionSelected", {
        status: "private",
        formData: this.formData
      });
    },
    closeModal() {
      this.$emit("closeModal");
    },
  },
  computed: {
    ...mapState("guests", {
      guestEmail: state => state.email
    }),
    ...mapState("guests", {
      guestPhone: state => state.phone
    })
  }
};
</script>

<style>
#failed-search-modal {
  background: rgba(0, 0, 0, 0.45);
}

#failed-search-modal.fade:not(.show) {
  opacity: 1;
  display: block;
}

.alert-wide {
  max-width: 850px !important;
}

.swal2-icon .swal2-icon-content {
  display: flex;
  align-items: center;
  font-size: 3.75em;
}

div.modal-content {
  border: none;
  border-radius: 10px;
}

div.modal-body {
  padding: 15px 45px;
}

div.close.close-modal {
  float: none;
  position: absolute;
  top: 0px;
  right: 5px;
  z-index: 999;
}
</style>
